<template>
  <el-card
    v-if="!fadeOut"
    :class="{ brokered: transport.brokered }"
    shadow="hover"
  >
    <div
      slot="header"
      class="flex items-center justify-between gap-0.5 max-h-5"
    >
      <div class="flex items-center gap-0.5">
        <check-marker
          :item="{
            id: transport.id,
            marker: transport.marker,
            target: 'route',
          }"
          :size="18"
        />
        <a @click.stop="toEdit">
          <svg
            width="18"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M5.433 13.917l1.262-3.155A4 4 0 017.58 9.42l6.92-6.918a2.121 2.121 0 013 3l-6.92 6.918c-.383.383-.84.685-1.343.886l-3.154 1.262a.5.5 0 01-.65-.65z"
            ></path>
            <path
              d="M3.5 5.75c0-.69.56-1.25 1.25-1.25H10A.75.75 0 0010 3H4.75A2.75 2.75 0 002 5.75v9.5A2.75 2.75 0 004.75 18h9.5A2.75 2.75 0 0017 15.25V10a.75.75 0 00-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5z"
            ></path>
          </svg>
        </a>
        <alter-request
          :requester="{
            id: transport.id,
            type: 'Transport',
            attr: 'appt_date',
          }"
        >
          <a v-if="item.appt_date">
            {{ item.appt_date | usFormat({ year: false }) }}
          </a>
          <svg
            v-else
            width="18"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
            ></path>
          </svg>
        </alter-request>
      </div>
      <div class="grow flex items-center justify-between" @click="toggleDetail">
        <div class="drivers">
          <div class="driver1" v-if="transport.trucker.name">
            <popup
              name=""
              className="no-underline"
              componentPath="pages/drivers/activity"
              width="400px"
              :inner="true"
              :pivot-y="0"
              :options="{
                id: transport.trucker_id,
                name: transport.trucker.name,
              }"
            >
              <svg
                width="18"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"
                ></path>
              </svg>
            </popup>
            <a
              v-if="chatable"
              class="no-underline"
              @click.stop="popupChat(transport.trucker.uuid)"
            >
              <svg
                width="18"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
                ></path>
              </svg>
            </a>
            <div class="grow name">{{ transport.trucker.name }}</div>
          </div>
          <div class="driver2" v-if="transport.trucker2.name">
            <popup
              name=""
              className="no-underline"
              componentPath="pages/drivers/activity"
              width="400px"
              :inner="true"
              :pivot-y="0"
              :options="{
                id: transport.trucker2_id,
                name: transport.trucker2.name,
              }"
            >
              <svg
                width="12"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"
                ></path>
              </svg>
            </popup>
            <a
              v-if="chatable"
              class="no-underline"
              @click.stop="popupChat(transport.trucker2.uuid)"
            >
              <svg
                width="12"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
                ></path>
              </svg>
            </a>
            <div class="grow name">{{ transport.trucker2.name }}</div>
          </div>
          <div class="carrier" v-if="transport.carrier.name">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.74902 7.37158V16.3442C5.74902 17.4488 6.64445 18.3442 7.74902 18.3442H16.6224"
                stroke="#2F80ED"
                stroke-width="1.8"
              ></path>
              <path
                d="M16.6885 10.9565L6.37305 10.9565"
                stroke="#2F80ED"
                stroke-width="1.8"
              ></path>
              <circle
                cx="5.92236"
                cy="4.55713"
                r="3.65713"
                stroke="#2F80ED"
                stroke-width="1.8"
              ></circle>
              <circle
                cx="19.1357"
                cy="10.8716"
                r="2.6"
                stroke="#2F80ED"
                stroke-width="1.8"
              ></circle>
              <circle
                cx="19.1357"
                cy="18.3442"
                r="2.6"
                stroke="#2F80ED"
                stroke-width="1.8"
              ></circle>
            </svg>
            <div class="grow name">{{ transport.carrier.name }}</div>
          </div>
        </div>
        <div v-if="transport.brokered">
          <a
            v-if="transport.carrier_id"
            :href="transport.carrier_signature?.url"
            :class="{
              green: transport.carrier_signature?.signed,
              gray: !transport.carrier_signature?.signed,
            }"
            target="_blank"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M22 22H2v-2h20v2M6.2 17.3l-.7.7l-1.4-1.4L2.7 18l-.7-.7l1.4-1.4L2 14.5l.7-.7l1.4 1.4l1.4-1.4l.7.7l-1.4 1.4l1.4 1.4m10.02-2.87c0-.58-.72-1.23-2.16-1.97c-1.83-.92-3.06-1.67-3.7-2.22c-.65-.56-.97-1.18-.97-1.87c0-1.78.91-3.25 2.73-4.42c1.82-1.17 3.31-1.76 4.45-1.76c.74 0 1.28.13 1.61.39c.32.25.5.69.5 1.32c0 .28-.12.52-.37.73c-.24.2-.44.3-.57.3c-.11 0-.31-.1-.61-.29l-.58-.26c-.47 0-1.41.33-2.84 1c-1.42.66-2.13 1.41-2.13 2.25c0 .51.24.97.74 1.37c.5.42 1.39.93 2.68 1.53c1.03.47 1.86.97 2.5 1.54c.6.54.91 1.18.91 1.93c0 1.34-.94 2.41-2.83 3.17c-1.88.77-3.68 1.15-5.39 1.15c-1.44 0-2.19-.49-2.19-1.46c0-.36.19-.59.5-.75c.33-.16.66-.24 1-.24l.75.13l.72.13c.98 0 2.03-.16 3.16-.49c1.13-.32 1.83-.73 2.09-1.21Z"
              />
            </svg>
          </a>
        </div>
        <div v-else class="w-12 flex items-center justify-end gap-0.5">
          <el-tooltip
            v-if="!isEmptyData(transport.driver_comment)"
            placement="bottom"
            effect="light"
          >
            <template slot="content">
              <pre>{{ transport.driver_comment }}</pre>
            </template>
            <a class="red" @click.stop>
              <svg
                width="18"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M3.505 2.365A41.369 41.369 0 019 2c1.863 0 3.697.124 5.495.365 1.247.167 2.18 1.108 2.435 2.268a4.45 4.45 0 00-.577-.069 43.141 43.141 0 00-4.706 0C9.229 4.696 7.5 6.727 7.5 8.998v2.24c0 1.413.67 2.735 1.76 3.562l-2.98 2.98A.75.75 0 015 17.25v-3.443c-.501-.048-1-.106-1.495-.172C2.033 13.438 1 12.162 1 10.72V5.28c0-1.441 1.033-2.717 2.505-2.914z"
                ></path>
                <path
                  d="M14 6c-.762 0-1.52.02-2.271.062C10.157 6.148 9 7.472 9 8.998v2.24c0 1.519 1.147 2.839 2.71 2.935.214.013.428.024.642.034.2.009.385.09.518.224l2.35 2.35a.75.75 0 001.28-.531v-2.07c1.453-.195 2.5-1.463 2.5-2.915V8.998c0-1.526-1.157-2.85-2.729-2.936A41.645 41.645 0 0014 6z"
                ></path>
              </svg>
            </a>
          </el-tooltip>
          <el-tooltip
            :content="transport.viewed_at || 'Order is not viewed yet'"
            placement="top"
            :open-delay="1000"
          >
            <a :class="transport.viewed_at ? 'green' : 'gray'" @click.stop>
              <svg
                width="18"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"></path>
                <path
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                  d="M.664 10.59a1.651 1.651 0 010-1.186A10.004 10.004 0 0110 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0110 17c-4.257 0-7.893-2.66-9.336-6.41zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                ></path>
              </svg>
            </a>
          </el-tooltip>
          <el-popconfirm
            v-if="transport.notifiable"
            title="Are you sure to notify this driver?"
            confirmButtonText="Confirm"
            cancelButtonText="Cancel"
            @confirm="notifyTrucker"
          >
            <a
              :class="transport.notified ? 'green' : 'red'"
              slot="reference"
              @click.stop
            >
              <svg
                v-if="transport.notified"
                width="18"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path fill="none" d="M0 0h24v24H0V0z"></path>
                <path
                  d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.4 4.25l-6.54 4.09c-.65.41-1.47.41-2.12 0L4.4 8.25c-.25-.16-.4-.43-.4-.72 0-.67.73-1.07 1.3-.72L12 11l6.7-4.19c.57-.35 1.3.05 1.3.72 0 .29-.15.56-.4.72z"
                ></path>
              </svg>
              <svg
                v-else
                width="18"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.61 2.64548C20.1948 2.19021 21.6568 3.65224 21.2016 5.23705L17.1785 19.2417C16.5079 21.5761 13.3904 22.0197 12.1096 19.9629L10.3338 17.1113C9.84262 16.3226 9.96155 15.2974 10.6207 14.6383L14.4111 10.8479C14.8022 10.4567 14.8033 9.82357 14.4134 9.43373C14.0236 9.04389 13.3905 9.04497 12.9993 9.43614L9.20901 13.2265C8.54987 13.8856 7.52471 14.0046 6.73596 13.5134L3.88412 11.7375C1.82737 10.4567 2.27092 7.33918 4.60532 6.66858L18.61 2.64548Z"
                />
              </svg>
            </a>
          </el-popconfirm>
        </div>
      </div>
    </div>

    <div class="detail" v-if="showDetail">
      <slot v-if="editView">
        <el-form
          inline
          :model="transport"
          class="flex items-center gap-0.5 p-0.5"
        >
          <div class="route-date-picker">
            <svg
              class="calendar"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.28033 2.46967C7.13968 2.32902 6.94891 2.25 6.75 2.25C6.55109 2.25 6.36032 2.32902 6.21967 2.46967C6.07902 2.61032 6 2.80109 6 3V4.5H5.25C4.45435 4.5 3.69129 4.81607 3.12868 5.37868C2.56607 5.94129 2.25 6.70435 2.25 7.5V18.75C2.25 19.5456 2.56607 20.3087 3.12868 20.8713C3.69129 21.4339 4.45435 21.75 5.25 21.75H18.75C19.5456 21.75 20.3087 21.4339 20.8713 20.8713C21.4339 20.3087 21.75 19.5456 21.75 18.75V7.5C21.75 6.70435 21.4339 5.94129 20.8713 5.37868C20.3087 4.81607 19.5456 4.5 18.75 4.5H18V3C18 2.80109 17.921 2.61032 17.7803 2.46967C17.6397 2.32902 17.4489 2.25 17.25 2.25C17.0511 2.25 16.8603 2.32902 16.7197 2.46967C16.579 2.61032 16.5 2.80109 16.5 3V4.5H7.5V3C7.5 2.80109 7.42098 2.61032 7.28033 2.46967ZM19.8107 8.18934C20.092 8.47064 20.25 8.85218 20.25 9.25V18.75C20.25 19.1478 20.092 19.5294 19.8107 19.8107C19.5294 20.092 19.1478 20.25 18.75 20.25H5.25C4.85218 20.25 4.47064 20.092 4.18934 19.8107C3.90804 19.5294 3.75 19.1478 3.75 18.75V9.25C3.75 8.85218 3.90804 8.47064 4.18934 8.18934C4.47064 7.90804 4.85218 7.75 5.25 7.75H18.75C19.1478 7.75 19.5294 7.90804 19.8107 8.18934ZM19.1758 10.8965C19.1758 11.5868 18.6161 12.1465 17.9258 12.1465C17.6834 12.1465 17.4572 12.0775 17.2656 11.9581C17.2416 11.9462 17.2182 11.9322 17.1957 11.9161C17.1734 11.9 17.1528 11.8825 17.1339 11.8637C16.8542 11.6345 16.6758 11.2863 16.6758 10.8965C16.6758 10.2061 17.2354 9.64648 17.9258 9.64648C18.6161 9.64648 19.1758 10.2061 19.1758 10.8965ZM16.6882 12.6233C16.9125 12.7843 16.9638 13.0967 16.8028 13.321L15.7122 14.8407C15.5511 15.065 15.2388 15.1164 15.0144 14.9554C14.7901 14.7944 14.7387 14.482 14.8997 14.2576L15.9904 12.738C16.1514 12.5136 16.4638 12.4623 16.6882 12.6233ZM13.2246 15.3776L10.9188 13.7044C10.9438 13.6059 10.957 13.5027 10.957 13.3965C10.957 12.7061 10.3974 12.1465 9.70703 12.1465C9.01667 12.1465 8.45703 12.7061 8.45703 13.3965C8.45703 13.5555 8.48673 13.7076 8.5409 13.8476L6.9793 15.2397C6.79748 15.1365 6.58726 15.0776 6.36328 15.0776C5.67293 15.0776 5.11328 15.6373 5.11328 16.3276C5.11328 17.018 5.67293 17.5776 6.36328 17.5776C7.05364 17.5776 7.61328 17.018 7.61328 16.3276C7.61328 16.2298 7.60204 16.1346 7.58077 16.0432L9.24595 14.5587C9.38862 14.6153 9.54419 14.6465 9.70703 14.6465C9.92362 14.6465 10.1273 14.5914 10.305 14.4945L12.6134 16.1696C12.5891 16.267 12.5762 16.3688 12.5762 16.4736C12.5762 17.164 13.1358 17.7236 13.8262 17.7236C14.5165 17.7236 15.0762 17.164 15.0762 16.4736C15.0762 15.7833 14.5165 15.2236 13.8262 15.2236C13.6081 15.2236 13.4031 15.2795 13.2246 15.3776Z"
                fill="currentColor"
              />
            </svg>
            <el-date-picker
              size="mini"
              v-model="transport.appt_date"
              type="date"
              format="MM/dd"
              :value-format="'yyyy-MM-dd'"
              @focus="apptDateCached"
              @change="apptDateChanged('date-picker')"
              style="width: 72px"
            />
          </div>
          <div class="route-driver">
            <container-dispatch :transport="transport" />
          </div>
          <div class="route-btns">
            <div class="flex items-center gap-0.5">
              <el-popover
                v-if="transport.trucker_id"
                placement="bottom"
                trigger="click"
                width="240"
                v-model="saveVisible"
                :disabled="!savable"
              >
                <div class="flex flex-col">
                  <el-button-group class="p-2">
                    <el-button
                      size="mini"
                      type="warning"
                      class="w-1/2"
                      @click.stop="schedule(false)"
                    >
                      Save
                    </el-button>
                    <el-button
                      size="mini"
                      type="success"
                      class="w-1/2"
                      :disabled="!transport.appt_date"
                      @click.stop="schedule(true)"
                    >
                      Save & Notify
                    </el-button>
                  </el-button-group>
                  <center
                    v-if="!transport.appt_date"
                    class="text-2xs text-red-500"
                  >
                    You can't notify without appt date.
                  </center>
                </div>
                <el-button
                  slot="reference"
                  size="mini"
                  type="primary"
                  class="narrow"
                  :disabled="!savable"
                  icon="el-icon-check"
                  @click.stop
                />
              </el-popover>
              <el-button
                v-else
                size="mini"
                type="primary"
                class="narrow"
                @click.stop="schedule(false)"
                :disabled="!savable"
                icon="el-icon-check"
              />
              <el-button
                size="mini"
                type="danger"
                class="narrow"
                @click.stop="cancelEdit"
                icon="el-icon-close"
              />
            </div>
          </div>
          <el-alert
            v-if="transport.error"
            :title="transport.error"
            type="error"
          >
          </el-alert>
        </el-form>
      </slot>
      <slot v-else>
        <div
          v-for="operation in transport.operations"
          :key="operation.id"
          class="line-item"
          :class="{ pending: highlightPending(operation) }"
        >
          <div class="flex items-center justify-between">
            <div class="action">
              {{ operation.name }}
            </div>
            <div class="flex flex-col py-0.5 gap-0.5">
              <slot v-if="operation.date_entry">
                <el-popover
                  placement="right"
                  width="400"
                  trigger="manual"
                  v-model="operation.popover"
                >
                  <div class="red">{{ operation.operated_at_error }}</div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="left"
                    content="Arrival Time"
                    :open-delay="750"
                    :disabled="!operation.depart_supported"
                    slot="reference"
                  >
                    <div class="relative">
                      <div class="absolute top-0.5 right-0.5 z-50">
                        <svg
                          v-if="transport.locked"
                          width="14"
                          viewBox="0 0 16 16"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="red"
                        >
                          <path
                            d="M13 7h-1V5a4 4 0 1 0-8 0v2H3L2 8v6l1 1h10l1-1V8l-1-1zM5 5a3 3 0 1 1 6 0v2H5V5zm8 9H3V8h10v6z"
                          />
                        </svg>
                      </div>
                      <el-date-picker
                        v-if="operation.time_required"
                        :readonly="transport.locked"
                        size="mini"
                        v-model="operation.operated_at"
                        type="datetime"
                        :editable="false"
                        :format="dateTimeFormatWithoutYear"
                        :value-format="'yyyy-MM-dd HH:mm'"
                        class="plain dtp"
                        @focus="storeDateTime(operation, 'operated_at')"
                        @change="changeDateTime(operation, 'operated_at')"
                      />
                      <el-date-picker
                        v-else
                        size="mini"
                        v-model="operation.operated_at"
                        :readonly="transport.locked"
                        type="date"
                        :editable="false"
                        :format="'MM/dd'"
                        :value-format="'yyyy-MM-dd'"
                        class="plain dtp"
                        @focus="storeDateTime(operation, 'operated_at')"
                        @change="changeDateTime(operation, 'operated_at')"
                      />
                    </div>
                  </el-tooltip>
                </el-popover>
                <el-popover
                  v-if="operation.depart_supported"
                  placement="right"
                  width="400"
                  trigger="manual"
                  v-model="operation.popover"
                >
                  <div class="red">{{ operation.departed_at_error }}</div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="left"
                    content="Departure Time"
                    :open-delay="750"
                    slot="reference"
                  >
                    <div class="relative">
                      <div class="absolute top-0.5 right-0.5 z-50">
                        <svg
                          v-if="transport.locked"
                          width="14"
                          viewBox="0 0 16 16"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="red"
                        >
                          <path
                            d="M13 7h-1V5a4 4 0 1 0-8 0v2H3L2 8v6l1 1h10l1-1V8l-1-1zM5 5a3 3 0 1 1 6 0v2H5V5zm8 9H3V8h10v6z"
                          />
                        </svg>
                      </div>
                      <el-date-picker
                        :readonly="transport.locked"
                        size="mini"
                        v-model="operation.departed_at"
                        type="datetime"
                        :editable="false"
                        :format="dateTimeFormatWithoutYear"
                        :value-format="'yyyy-MM-dd HH:mm'"
                        class="plain dtp"
                        @focus="storeDateTime(operation, 'departed_at')"
                        @change="changeDateTime(operation, 'departed_at')"
                      />
                    </div>
                  </el-tooltip>
                </el-popover>
              </slot>
            </div>
            <div class="alter">
              <alter-request
                :requester="{
                  id: operation.id,
                  type: 'Operation',
                  attr: 'operated_at',
                }"
                :size="18"
              />
              <alter-request
                :requester="{
                  id: operation.id,
                  type: 'Operation',
                  attr: 'departed_at',
                }"
                :size="18"
              />
            </div>
            <div class="docs">
              <uploader
                :items="operation.images"
                :target="{
                  id: operation.id,
                  type: 'Operation',
                  required: operation.required_docs,
                }"
              />
            </div>
          </div>
          <div
            v-if="
              viewPickup && operation.operation_type.with_pickup_instruction
            "
            class="instructions pickup"
          >
            <div class="location">{{ operation.location }}</div>
            <el-input
              v-if="!operation.not_required_instruction"
              type="textarea"
              v-model.lazy="operation.instructions"
              @change="saveInstruction(operation)"
            />
            <div class="scale-80">
              <el-checkbox
                v-model.lazy="operation.not_required_instruction"
                @change="saveNotRequiredInstruction(operation)"
                >Non-Required</el-checkbox
              >
            </div>
          </div>
          <div
            v-if="
              viewEmptyReturn &&
              operation.operation_type.with_return_instruction
            "
            class="instructions empty-return"
          >
            <div>{{ operation.location }}</div>
            <el-input
              v-if="!operation.not_required_instruction"
              type="textarea"
              v-model.lazy="operation.instructions"
              @change="saveInstruction(operation)"
            />
            <el-checkbox
              v-model.lazy="operation.not_required_instruction"
              @change="saveNotRequiredInstruction(operation)"
            >
              <span class="text-xs tracking-tighter">
                Instruction Not Required
              </span>
            </el-checkbox>
          </div>
        </div>
        <div class="p-1" v-if="viewTasks">
          <container-transport-tasks
            :id="transport.id"
            :check_tasks="transport.check_tasks"
            :compact="true"
          />
        </div>
      </slot>
    </div>
  </el-card>
</template>
<script>
import api from "@/default/utils/api";
import { dateTimeComputed } from "@/default/utils/computed";

export default {
  name: "ContainerTransport",
  mixins: [api],
  props: {
    container: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    detail: {
      type: String,
      default: "default",
    },
    curApptDate: {
      type: String,
      default: null,
    },
    viewTasks: {
      type: Boolean,
      default: false,
    },
    viewPickup: {
      type: Boolean,
      default: false,
    },
    viewEmptyReturn: {
      type: Boolean,
      default: false,
    },
    highlight: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      transport: Object.assign({}, this.item),
      showDetail: true,
      editView: false,
      saveVisible: false,
    };
  },
  async mounted() {
    if (this.item.cached) {
      if (this.item.cached.editView) await this.toEdit();
      this.transport = { ...this.transport, ...this.item.cached };
    }
    this.showDetail = this.defaultDetailDisplay;
    if (this.highlight) {
      this.showDetail = this.item.operations.some((o) => {
        return this.highlightPending(o);
      });
    }

    if (!this.fadeOut && this.item.brokered) {
      this.$set(this.container, "brokered", true);
    }
  },
  beforeDestroy() {
    this.$set(this.item, "cached", {
      editView: this.editView,
      appt_date: this.transport.appt_date,
      trucker_id: this.transport.trucker_id,
      truck_id: this.transport.truck_id,
      payable_party_id: this.transport.payable_party_id,
      trucker2_id: this.transport.trucker2_id,
      payable_party2_id: this.transport.payable_party2_id,
    });
    this.transport = {};
  },
  watch: {
    detail(nv, ov) {
      if (nv != ov) {
        this.showDetail = this.defaultDetailDisplay;
      }
    },
  },
  computed: {
    ...dateTimeComputed,
    chatable() {
      return typeof window.ChatPopup == "object";
    },
    fadeOut() {
      return (
        this.curApptDate &&
        this.item.appt_date &&
        this.curApptDate != this.item.appt_date
      );
    },
    savable() {
      return (
        this.transport.trucker_id != this.item.trucker_id ||
        this.transport.truck_id != this.item.truck_id ||
        this.transport.payable_party_id != this.item.payable_party_id ||
        this.transport.trucker2_id != this.item.trucker2_id ||
        this.transport.payable_party2_id != this.item.payable_party2_id ||
        this.transport.appt_date != this.item.appt_date ||
        this.transport.tenant ||
        this.transport.carrier_id
      );
    },
    defaultDetailDisplay() {
      let visible = true;
      const { appt_date, operations } = this.item;
      switch (this.detail) {
        case "expand":
          visible = true;
          break;
        case "collapse":
          visible = false;
          break;
        default:
          switch (this.source) {
            case "order-stack":
              if (!appt_date) {
                visible = false;
              } else {
                visible ||= operations.some((o) => {
                  return o.pending;
                });
              }
              break;
            default:
              if (appt_date != this.curApptDate) {
                visible = false;
              } else {
                visible = !this.item.completed;
              }
              break;
          }
          break;
      }
      return visible;
    },
    highlightPending() {
      return function (operation) {
        return this.highlight && operation.incompleted;
      };
    },
  },
  methods: {
    toggleDetail() {
      this.showDetail = !this.showDetail;
      window.dispatchEvent(new Event("resize"));
    },
    storeDateTime(operation, target) {
      return (operation.cached_datetime = operation[target]);
    },
    async changeDateTime(operation, target) {
      if (operation.delivery_mark) {
        const info = "Are you sure to set time on the behalf of the driver?";
        try {
          await this.$confirm(info);
          await this.setOpDate(operation, target);
        } catch {
          this.$set(operation, target, operation.cached_datetime);
        }
      } else {
        await this.setOpDate(operation, target);
      }
    },
    async setOpDate(operation, target) {
      const actions = { operated_at: "arrive", departed_at: "depart" };
      try {
        const response = await this.$http.patch(
          `/api/v1/operations/${operation.id}/${actions[target]}`,
          {
            datetime: operation[target],
            pos: operation.pos,
            sequence: operation.sequence,
          },
        );

        this.$set(operation, target, response.data.datetime);
        this.$set(operation, "popover", false);
      } catch (err) {
        this.$set(operation, target, operation.cached_datetime);
        this.$set(operation, `${target}_error`, err.response.data.errors);
        this.$set(operation, "popover", true);
        setTimeout(() => this.$set(operation, "popover", false), 5000);
      }
    },
    async notifyTrucker() {
      try {
        const response = await this.$http.patch(
          `/api/v1/transports/${this.transport.id}/notify`,
        );
        this.transport = response.data;
      } catch (err) {
        NApp.flashNoticeOut(err.response.data.errors, "error");
      }
    },
    apptDateCached() {
      this.$set(this.transport, "appt_date_cached", this.transport.appt_date);
    },
    async apptDateChanged(source = null) {
      const { appt_date } = this.transport;
      if (appt_date) {
        const animate = document.querySelector(
          `span[data-date="${appt_date}"] .animate-ping`,
        );
        if (animate) {
          animate.classList.remove("hidden");
          setTimeout(() => animate.classList.add("hidden"), 1000);
        }
      }

      try {
        if (source == "date-picker" && appt_date) {
          if (new Date().ymd() > appt_date) {
            await this.$confirm(
              "The appointment date is in the past. Are you sure to continue?",
              "Warning",
              {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning",
              },
            );
          }
        }
        const response = await this.$http.get("/api/v1/transports/truckers", {
          params: {
            id: this.transport.id,
            appt_date,
          },
        });
        this.$set(this.transport, "truckers", response.data);
      } catch (err) {
        this.$set(this.transport, "appt_date", this.transport.appt_date_cached);
      }
    },
    async toEdit() {
      try {
        const url = `/api/v1/transports/${this.transport.id}/changable`;
        const { trucker, carrier } = (await this.$http.get(url)).data;
        this.$set(this.transport.trucker, "changable", trucker);
        this.$set(this.transport.carrier, "changable", carrier);
        if (this.transport.trucker.changable) {
          if (this.transport.truckers == null) {
            await this.apptDateChanged();
          }
          this.editView = true;
          this.showDetail = true;
        }
      } catch (err) {
        this.$message({
          message: err.response.data.errors,
          type: "error",
        });
      }
    },
    cancelEdit() {
      this.editView = false;
      this.showDetail = true;
      this.transport = Object.assign({}, this.item);
    },
    async schedule(notify = false) {
      this.saveVisible = false;
      const fields = [
        "appt_date",
        "trucker_id",
        "truck_id",
        "payable_party_id",
        "trucker2_id",
        "payable_party2_id",
        "tenant",
        "carrier_id",
      ];
      const attrs = this._.pick(this.transport, fields);

      try {
        const response = await this.$http.patch(
          `/api/v1/transports/${this.transport.id}/schedule`,
          {
            transport: attrs,
            notify,
          },
        );

        Object.assign(this.transport, response.data);
        delete this.transport.error;
        this.editView = false;
        this.showDetail = true;
        this.$emit("reloadOrder");
      } catch (err) {
        this.$set(this.transport, "error", err.response.data.errors);
      }
    },
    async saveInstruction(item) {
      item.type = "Operation";
      await this.autoSave(item, "instructions", item.instructions);
    },
    async saveNotRequiredInstruction(item) {
      item.type = "Operation";
      await this.autoSave(
        item,
        "not_required_instruction",
        item.not_required_instruction,
      );
    },
    async autoSave(item, column, value) {
      const params = { type: item.type, column, value };

      try {
        await this.$http.put(`/api/v1/attrs/${item.id}`, params);
        this.$message({
          message: "It was changed successfully",
          type: "success",
        });
      } catch (err) {
        this.$message({ message: err.response.data.errors, type: "error" });
      }
    },
    popupChat(uuid) {
      window.ChatPopup.selectRoom(uuid);
    },
  },
};
</script>

<style lang="scss" scoped>
.is-brokered {
  @apply bg-sky-50 px-1 border rounded;
}
.el-card::v-deep {
  @apply border border-gray-400;

  &:not(:last-child) {
    @apply mb-0.5;
  }

  &.brokered {
    .el-card__header {
      @apply bg-pink-200;
    }
  }

  .el-card__header {
    @apply cursor-pointer px-0.5 py-1 box-border bg-blue-50 text-blue-500;
  }

  .el-card__body {
    @apply p-0 empty:hidden border-t border-gray-400;
  }

  .drivers {
    @apply grow flex flex-col text-left font-normal;

    .driver1 {
      @apply text-xs font-semibold flex items-center gap-0.5;
    }

    .driver2 {
      @apply text-2xs font-semibold flex items-center gap-1 ml-1.5 -mt-1;
    }

    .carrier {
      @apply text-xs font-semibold flex items-center gap-0.5 max-w-52;
    }

    .name {
      @apply whitespace-nowrap overflow-hidden overflow-ellipsis;
    }
  }

  .detail {
    @apply p-0;

    .line-item {
      &:not(:last-child) {
        @apply border-b border-gray-200;
      }

      &.pending {
        @apply bg-yellow-100;
      }
    }
    .route-date-picker {
      @apply relative flex-shrink-0;
      svg.calendar {
        @apply absolute top-1 left-0 z-50;
      }
      .el-input--mini {
        .el-input__prefix {
          @apply hidden;
        }
      }
    }
    .route-driver {
      @apply flex items-center border border-gray-400 p-1 h-7 rounded min-w-0 flex-1;
      & > span {
        @apply w-full;
      }
    }
    .route-btns {
      @apply flex-shrink-0;
    }

    .action {
      @apply font-semibold w-28 whitespace-nowrap tracking-tighter overflow-hidden text-left pl-1 py-1 text-ellipsis;
    }

    .alter {
      @apply w-5;

      .alter-request {
        @apply leading-3;
      }
    }

    div.docs {
      @apply w-16;
    }

    div.instructions {
      @apply p-0.5 m-0.5 text-left border border-gray-400 rounded-sm;
      .location {
        @apply text-white font-semibold bg-red-400 p-1 mb-0.5 rounded-sm empty:hidden;
      }

      textarea {
        @apply text-xs font-normal p-0.5 leading-3 h-12;
      }

      &.pickup {
        @apply bg-orange-200;
      }

      &.empty-return {
        @apply bg-purple-200;
      }
    }
  }

  .el-date-editor.dtp {
    @apply w-28 h-5 border border-gray-300 rounded-sm;

    input {
      @apply font-bold tracking-tighter leading-5 h-5 py-0 px-4 cursor-pointer hover:bg-slate-200 #{!important};
    }

    .el-input__prefix {
      @apply left-0 #{!important};
    }
    .el-input__suffix {
      .el-input__icon {
        @apply text-red-500 text-sm #{!important};
      }
    }
    .el-input__icon {
      @apply leading-5 h-5 #{!important};
    }
  }
}
</style>
